import React from "react";
import { connect } from "react-redux";
import "./App.css";
import "./Global/style.css";
import Main from "./Main.js";
import logout from "./Global/logout";
import Loader from "./Global/loader";
import checkJwt from "./Global/jwtChecker";
import getUsersInfo from "./API/Client/GetUserInfo";
import i18n from "i18next";
import './main.scss'
import './tabs.scss'
import './table.scss'

class App extends React.Component {
    state = {
        refresh: true
    };

    componentDidMount = async () => {
        const unHashedJwt = await checkJwt();

        if (
            unHashedJwt === undefined ||
            sessionStorage.getItem("token") === null
        ) {
            await logout();
        } else {
            /* Get user info and save it */
            let userInfo = await getUsersInfo();

            if (userInfo.data.status === 401) {
                await logout();
            }
            else
            {
                await this.props.mapState("MAP_ALL_INFO", userInfo.data.data);
                i18n.changeLanguage(userInfo.data.data.user_web_properties.settings.language);  
            }
        }

        // set theme color
        document.documentElement.className = "";      
        document.documentElement.classList.add(`theme-`+ this.props.user.user_web_properties.settings.themeColor);

        this.setState({ refresh: false });
    };

    render() {
        return (
            <>
                {this.state.refresh ? <Loader /> : <Main />}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
    };
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);